import { Platform, View } from 'react-native'
import React from 'react'
import { Skeleton } from 'moti/skeleton'
import dimensions from '../../../../../globalStyles/dimensions'

const ExperienceLoader = () => {
  return (
    <>
        <Skeleton width={dimensions.windowWidth} height={dimensions.windowHeight/2} colorMode='light' />
        <View style={{gap: 10, paddingHorizontal: Platform.OS === 'web' ? 20 : dimensions.paddingHorizontal, paddingVertical: dimensions.paddingVertical}}>
            <Skeleton width={100} height={30} radius={8} colorMode='light'/>
            <Skeleton width={ Platform.OS === 'web' ?  328 : dimensions.windowWidth/1.2} height={20} radius={8} colorMode='light' />
            <Skeleton width={Platform.OS === 'web' ?  328 : dimensions.windowWidth/1.2} height={20} radius={8} colorMode='light' />
            <View style={{gap: 10}}>
            <Skeleton width={Platform.OS === 'web' ?  200 : dimensions.windowWidth/2} height={20} radius={8} colorMode='light' />
            <View style={{flexDirection: 'row', gap: 8}}>
                <Skeleton width={200} height={200} radius={8} colorMode='light' />
                <Skeleton width={200} height={200} radius={8} colorMode='light' />
            </View>
            </View>
        </View>
    </>
  )
}

export default ExperienceLoader